import LegalLayout from "./LegalLayout";

export default function HipaaNotice() {
  return (
    <LegalLayout title="HIPAA Notice & Business Associate Statement" lastUpdated="April 21, 2026">
      <p>
        LegacyGrowth Engine is built for licensed home-care and group-home
        operators that handle Protected Health Information ("PHI") under the
        Health Insurance Portability and Accountability Act of 1996 ("HIPAA")
        and its implementing regulations.
      </p>

      <h2>1. Our role</h2>
      <p>
        When you use the Service to capture, store, or transmit PHI, H&amp;E
        Associates LLC acts as a "Business Associate" of your agency
        ("Covered Entity") under 45 CFR §160.103. Your subscription includes a
        Business Associate Agreement ("BAA") that you sign electronically
        during onboarding. Until that BAA is signed, you must not enter PHI
        into the Service.
      </p>

      <h2>2. Safeguards we implement</h2>
      <ul>
        <li><strong>Administrative</strong> — least-privilege access for personnel, mandatory security training, documented incident-response plan.</li>
        <li><strong>Physical</strong> — PHI is hosted in SOC 2-audited US data centers operated by our infrastructure providers.</li>
        <li><strong>Technical</strong> — TLS 1.2+ encryption in transit, AES-256 encryption at rest, row-level security in the database, role-based application permissions, audit logging, automatic 30-minute session inactivity logout.</li>
      </ul>

      <h2>3. Sub-processors</h2>
      <p>
        We maintain BAAs with every sub-processor that may receive PHI,
        including our cloud database, email-delivery, and SMS providers. A
        current sub-processor list is available on request.
      </p>

      <h2>4. Your responsibilities</h2>
      <ul>
        <li>Sign the BAA before entering any PHI.</li>
        <li>Limit PHI input to the minimum necessary for the workflow.</li>
        <li>Manage your team's access (invite, role, removal) and revoke promptly when staff leave.</li>
        <li>Honor patient/client rights of access, amendment, and accounting of disclosures.</li>
      </ul>

      <h2>5. Breach notification</h2>
      <p>
        If we discover a breach of unsecured PHI we will notify your designated
        privacy contact without unreasonable delay and no later than 60 days
        after discovery, with the information required by 45 CFR §164.410.
      </p>

      <h2>6. Patient rights</h2>
      <p>
        Patients should direct requests for access, amendment, or accounting of
        disclosures to the Covered Entity (your agency). We will support those
        requests by providing the data we hold on the patient's behalf within
        the timeframes the BAA requires.
      </p>

      <h2>7. Termination</h2>
      <p>
        On termination of the BAA we will return or securely destroy all PHI
        within 30 days, except where retention is required by law (in which
        case we will continue to safeguard it and limit further use).
      </p>

      <h2>8. Contact</h2>
      <p>
        Privacy &amp; Security Officer:{" "}
        <a href="mailto:privacy@legacygrowthengine.com">privacy@legacygrowthengine.com</a>
      </p>
      <p className="text-xs italic">
        This notice summarizes our HIPAA practices and does not replace the
        signed BAA. In any conflict between this page and your signed BAA, the
        signed BAA controls.
      </p>
    </LegalLayout>
  );
}